/**
 * Who judged a finding's severity, in words — the SEVERITY provenance axis. Kept honest and distinct
 * from the EVIDENCE axis: 'defenssive' is our own judgement even when the evidence is Microsoft's (a
 * Secure Score band, for instance), and only Defender-authored CVE severities are genuinely Microsoft's.
 * An unknown/absent value never invents an origin — it reads "Not recorded".
 *
 * One definition for every screen: the findings list printed the stored value ("per
 * microsoft_secure_score") while the detail page said "Microsoft Secure Score".
 */
export function severitySourceLabel(source: string | null | undefined): string {
  switch (source) {
    case 'defenssive':
      return 'Defenssive'
    case 'defender':
      return 'Microsoft Defender'
    case 'microsoft_secure_score':
      return 'Microsoft Secure Score'
    case 'purview':
      return 'Microsoft Purview'
    // The Cloud (Azure) checks' own rating. The tool is not named on screen (owner, 2026-10-10,
    // option C), but the rating is still said to be the check's, not ours.
    case 'prowler':
      return 'Azure check'
    default:
      return source && source.length > 0 ? source : 'Not recorded'
  }
}
